/**
 * @file formUserInputOptionConstants
 * 個人情報入力画面で利用する選択肢の定数
 */
import {AgeLimit} from '@/js/util/constants'
import {wareki} from '@/js/util/helper'

/**
 * 申込日 「年」選択肢
 * 当日の年 + 前後1年
 */
export const ApplicationYears = () => {
  const currentYear = new Date().getFullYear()
  const startYear = currentYear - 1
  const endYear = currentYear + 1
  const diffYear = endYear + 1 - startYear
  const applicationYears = [...Array(diffYear).keys()].map((i) => {
    const tmp = i + startYear
    // const w = wareki(tmp)
    return {
      value: `${tmp}`,
      // label:`${tmp}年（${w}）`
      label: `${tmp}年`
    }
  })
  return applicationYears
}

/**
 * 生年月日 「年」選択肢
 * @param {string} has_payment // credit or installment
 */
export const BirthdayYears = (has_payment) => {
  const startYear = new Date().getFullYear() - (AgeLimit[has_payment].high + 1)
  const diffYear = new Date().getFullYear() - (AgeLimit[has_payment].low - 1) - startYear
  const birthdayYears = [...Array(diffYear).keys()].map((i) => {
    const tmp = i + startYear
    // const w = wareki(tmp)
    return {
      value: `${tmp}`,
      // label: `${tmp}年（${w}）`
      label: `${tmp}年`
    }
  })
  return birthdayYears.slice().reverse()
}

/**
 * 卒業予定
 * 申込日の年 + 10年後まで
 * @param {number} year
 */
export const GranduateYear = (year) => {
  let currentYear
  currentYear = year ? new Date(String(year)).getFullYear() : new Date().getFullYear()

  const granduateYear = [...Array(10).keys()].map((i) => {
    const tmp = i + currentYear
    return {
      value: `${tmp}`,
      label: `${tmp}年`
    }
  })
  return granduateYear
}

/**
 * 入社年月「年」選択肢(2022年～1972年の50年で選択)
 * 例: 2022年～1972年の50年で選択(2022年の場合)
 * 例: 2023年～1973年の50年で選択(2023年の場合)
 */
 export const JoinYears = () => {
  const diffYear = 51
  const startYear = new Date().getFullYear() - diffYear
  const joinYears = [...Array(diffYear).keys()].map((i) => {
    const tmp = startYear + i + 1
    return {
      value: `${tmp}`,
      label: `${tmp}年`
    }
  })
  return joinYears.slice().reverse()
}

/**
 * 今日の日付を配列で返す[YYYY,MM,DD]
 */
export const CurrentDate = () => {
  const year = new Date().getFullYear()
  const month = new Date().getMonth() + 1
  const date = new Date().getDate()
  return [year, month, date]
}

/**
 * 月選択
 */
export const Months = [
  {key: '', value: '1'},
  {key: '', value: '2'},
  {key: '', value: '3'},
  {key: '', value: '4'},
  {key: '', value: '5'},
  {key: '', value: '6'},
  {key: '', value: '7'},
  {key: '', value: '8'},
  {key: '', value: '9'},
  {key: '', value: '10'},
  {key: '', value: '11'},
  {key: '', value: '12'}
]

/**
 * 取引を行う目的
 */
export const PurposeOfTransaction = [
  {key: '', label: '生計費決済', value: '生計費決済'},
  {key: '', label: 'その他', value: 'その他'}
]

/**
 * 外国政府等重要な公的地位にある方等とのお取引に該当する
 */
export const IsForeignGovernment = [
  {key: '', label: 'はい', value: 'はい'},
  {key: '', label: 'いいえ', value: 'いいえ'}
]

/**
 * 性別選択
 */
export const SexType = [
  {key: '', label: '女性', value: 2},
  {key: '', label: '男性', value: 1}
]

/**
 * 生年月日 元号
 */
export const BirthdayEra = [
  {key: '', value: '昭和'},
  {key: '', value: '平成'}
]

/**
 * 配偶者有無選択
 */
export const HasSpouse = [
  {key: '', value: '有'},
  {key: '', value: '無'}
]

/**
 * 親同居有無選択
 */
export const ParentLiving = [
  {key: '', value: '有'},
  {key: '', value: '無'}
]

/**
 * 子供有無
 */
export const ChildStatus = [
  {key: '', value: '有'},
  {key: '', value: '無'}
]

/**
 * ご家族 > その他人数有無
 */
export const OthersStatus = [
  {key: '', value: '有'},
  {key: '', value: '無'}
]

/**
 * ご家族について
 */
export const FamilyAbout = [
  {key: '', label: '独身（家族別居）', value: '独身（家族別居）'},
  {key: '', label: '独身（家族同居）', value: '独身（家族同居）'},
  {key: '', label: '配偶者有子供有', value: '配偶者有子供有'},
  {key: '', label: '配偶者有子供無', value: '配偶者有子供無'},
  {key: '', label: '配偶者無子供有', value: '配偶者無子供有'}
]

/**
 * 世帯人数（同一生計人数）
 */
export const FamilyStructure = [
  {key: '', value: 1, label: '1人（ご本人様のみ）'},
  {key: '', value: 2, label: '2人'},
  {key: '', value: 3, label: '3人'},
  {key: '', value: 4, label: '4人以上'}
]

/**
 * 住居形態選択
 */
export const ResidenceClassification = [
  {key: '', label: '自己資産（共同含む）', value: '自己資産（共同含む）'},
  {key: '', label: '家族持家', value: '家族持家'},
  {key: '', label: '賃貸', value: '賃貸'},
  {key: '', label: '寮、下宿', value: '寮、下宿'},
  {key: '', label: '社宅、官舎', value: '社宅、官舎'}
]

/**
 * 居住年数(月選択)
 */
export const ResidencePeriodYears = [
  {key: '', label: '1年未満', value: '1年未満'},
  {key: '', label: '1年以上5年未満', value: '1年以上5年未満'},
  {key: '', label: '5年以上10年未満', value: '5年以上10年未満'},
  {key: '', label: '10年以上', value: '10年以上'}
]

/**
 * 家賃・ローンの支払い
 */
export const LoanRent = [
  {key: '', label: '支払いあり', value: '支払いあり'},
  {key: '', label: '支払いなし', value: '支払いなし'}
]

/**
 * お申込者と世帯主の関係
 */
export const HouseholderRelation = [
  {key: '', label: '本人', value: '本人'},
  {key: '', label: '配偶者', value: '配偶者'},
  {key: '', label: '親', value: '親'},
  {key: '', label: '兄弟・姉妹', value: '兄弟・姉妹'},
  {key: '', label: '祖父母', value: '祖父母'},
  {key: '', label: 'その他', value: 'その他'}
]

/**
 * 世帯主の所得種類
 */
export const HouseholderIncomeType = [
  {key: '', label: '給与所得', value: '給与所得'},
  {key: '', label: '事業所得', value: '事業所得'},
  {key: '', label: '年金受給', value: '年金受給'},
  {key: '', label: 'その他', value: 'その他'}
]

/**
 * 実家携帯電話の続柄情報
 */
export const ParentsPhoneRelationship = [
  {key: '', label: '父', value: '父'},
  {key: '', label: '母', value: '母'},
  {key: '', label: '配偶者', value: '配偶者'},
  {key: '', label: '兄弟・姉妹', value: '兄弟・姉妹'},
  {key: '', label: 'その他', value: 'その他'},
  {key: '', label: '', value: null},
]

/**
 * 世帯主と同居しているか別居か
 */
// export const LivingWithHouseHolder = [
//     { key: '', value: '同居' },
//     { key: '', value: '別居' }
// ]

/**
 * お勤め先・学校について(職業選択)
 */
export const Occupation = {
  // 自社割賦
  credit: [
    {key: '', value: '会社員'},
    {key: '', value: '会社員（管理職以上）'},
    {key: '', value: 'パート・アルバイト'},
    {key: '', value: '契約社員・準社員'},
    {key: '', value: '派遣社員'},
    {key: '', value: '自営業・役員'},
    {key: '', value: '公務員'},
    {key: '', value: '学生（アルバイト）'},
    {key: '', value: '専業主婦'},
    {key: '', value: '無職'},
    {key: '', value: 'その他'}
  ],
  // 信販
  installment: [
    {key: '', value: '会社員'},
    {key: '', value: '会社員（管理職以上）'},
    {key: '', value: 'パート・アルバイト'},
    {key: '', value: '契約社員・準社員'},
    {key: '', value: '派遣社員'},
    {key: '', value: '自営業・役員'},
    {key: '', value: '公務員'},
    {key: '', value: '学生（アルバイト）'},
    {key: '', value: '専業主婦'},
    {key: '', value: '無職'},
    {key: '', value: 'その他'}
  ]
}

/**
 * 就業形態選択
 */
// export const EmploymentStatus = {
//     // 自社割賦
//     credit: [
//         { key: '', value: '社員・職員' },
//         { key: '', value: '嘱託・契約社員' },
//         { key: '', value: '派遣社員' },
//         { key: '', value: '経営者・役員' },
//         { key: '', value: '公務員' },
//         { key: '', value: 'パート・アルバイト' },
//         { key: '', value: 'その他' }
//     ],
//     // 信販
//     installment: [
//         { key: '', value: '社員・職員' },
//         { key: '', value: '嘱託・契約社員' },
//         { key: '', value: '派遣社員' },
//         { key: '', value: '経営者・役員' },
//         { key: '', value: '公務員' },
//         { key: '', value: 'パート・アルバイト' },
//         { key: '', value: 'その他' }
//     ]
// }

/**
 * 仕事内容
 */

export const CompanyJobDescription = {
  // 信販
  credit: [
    {key: '飲食', value: '飲食'},
    {key: '事務', value: '事務'},
    {key: '教育', value: '教育'},
    {key: '技術', value: '技術'},
    {key: '営業', value: '営業'},
    {key: '医療機関', value: '医療機関'},
    {key: '福祉', value: '福祉'},
    {key: '販売', value: '販売'},
    {key: 'サービス', value: 'サービス　'},
    {key: '製造', value: '製造'},
    {key: '建築・工事', value: '建築・工事'},
    {key: '金融', value: '金融'},
    {key: '不動産', value: '不動産'},
    {key: 'その他', value: 'その他'}
  ],
  // 自社割賦
  installment: [
    {key: '飲食', value: '飲食'},
    {key: '事務', value: '事務'},
    {key: '教育', value: '教育'},
    {key: '技術', value: '技術'},
    {key: '営業', value: '営業'},
    {key: '医療機関', value: '医療機関'},
    {key: '福祉', value: '福祉'},
    {key: '販売', value: '販売'},
    {key: 'サービス', value: 'サービス　'},
    {key: '製造', value: '製造'},
    {key: '建築・工事', value: '建築・工事'},
    {key: '金融', value: '金融'},
    {key: '不動産', value: '不動産'},
    {key: 'その他', value: 'その他'}
  ]
}

/**
 * 給料日
 */
export const PayDay = () => {
  const payDay = []
  for (let i = 1; i < 32; i++) {
    const obj = {
      value: i,
      label: `${i}日`
    }
    payDay.push(obj)
  }
  payDay.push({value: 32, label: '日払い'})
  payDay.push({value: 33, label: '週払い'})

  return payDay
}

/**
 * その他年収
 */
export const SidelineType = [
  {key: '', label: '副収入', value: '副収入'},
  {key: '', label: '仕送り', value: '仕送り'},
  {key: '', label: 'その他', value: 'その他'}
]

/**
 * 値の変換key名と条件の配列
 */
export const Conversions = [
  {key: 'family_about_number', term: 'money'},
  {key: 'householder_income', term: 'money'},
  {key: 'householder_monthly_credit_payments', term: 'money'},
  {key: 'company_income', term: 'money'},
  {key: 'sideline_income', term: 'money'}
]
